/**
 *
 *
 *
 *
 *
 *  This is a special case component because SDL can not generate propper json.
 *
 *
 *
 *
 *
 *
 */
import React, { useEffect } from 'react';
import InputControl from './InputControl';
import Adress from '../components/SDL/InputTypes/Adress';
import BirthDay from '../components/SDL/InputTypes/BirthDay';
import HouseMemberCount from '../components/SDL/InputTypes/HouseMemberCount';
import Number from '../components/SDL/InputTypes/Number';
import Ombudsnummer from '../components/SDL/InputTypes/Ombudsnummer';
import OrganizationNumber from '../components/SDL/InputTypes/OrganizationNumber';
import PersonNumber from '../components/SDL/InputTypes/PersonNumber';
import PostCode from '../components/SDL/InputTypes/PostCode';
import PreloadList from '../components/SDL/InputTypes/PreloadList';
import Price from '../components/SDL/InputTypes/Price';
import VehicleType from '../components/SDL/InputTypes/VehicleType';
import StreetAddress from '../components/SDL/InputTypes/StreetAddress';
import { useConfiguration } from '../providers/Configuration';
import { useToggleMapping } from '../providers/Toggle';
import { useField } from 'react-final-form';
import Year from '../components/SDL/InputTypes/Year';
import Registration from '../components/SDL/InputTypes/Registration';

/**
 * Custom component for stupid case
 */
import Text from '../components/SDL/InputTypes/TextMoped';

/**
 * Check which component type the current InputField is.
 * SDL specifies certain inputTypes which is both used to infer the type of control
 * but also the groupings, i.e the inputType "Address" can be 2 different components, and both of them should be hide/show based on that fact.
 * but the "Postcode" inputType is also included in that show/hide group.
 */
export default function InputTypeMoped({ form, index, fieldCount = 0, ...props }) {
    return <TypeSwitch form={form} {...props}></TypeSwitch>;
}
function TypeSwitch({ form, inputType, components, ...props }) {
    const { configuration } = useConfiguration();

    /**
     * !! HACK SPECIFIC TO Moped banner
     */
    const group = 'mopedRegOrYear';
    const toggleMapping = useToggleMapping();
    const {
        input: { value }
    } = useField(toggleMapping[group]?.fieldName);

    useEffect(() => {
        if (toggleMapping[group][value] !== 'regnr') form.change('regnr');
        if (toggleMapping[group][value] !== 'arsmodell') form.change('arsmodell');
    }, [toggleMapping[group][value]]);

    switch (inputType) {
        case 'Address':
            switch (props.inputControl) {
                case 'DropDown':
                    return <Adress group={`address`} {...props} />;
                case 'TextField':
                    return <StreetAddress group={`address`} {...props} />;
                default:
                    return <Adress group={`address`} {...props} />;
            }
        case 'BirthDay':
            return <BirthDay {...props} />;
        case 'HouseMemberCount':
            return <HouseMemberCount {...props} />;
        case 'Number':
            return <Number {...props} />;
        case 'Ombudsnummer':
            return <Ombudsnummer {...props} />;
        case 'OrganizationNumber':
            return <OrganizationNumber {...props} />;
        case 'PersonNumber':
            return <PersonNumber {...props} />;
        case 'Postcode':
            return <PostCode group={`address`} {...props} />;
        case 'PreloadList':
            return <PreloadList categoryServiceUrl={configuration?.componentData?.categoryServiceUrl} {...props} />;
        case 'Price':
            return <Price {...props} />;
        case 'Registration':
            return toggleMapping[group][value] === 'regnr' ? <Registration {...props} /> : null;
        case 'Text':
            return <Text {...props} />;
        case 'Vehicle Type':
            return <VehicleType {...props} />;
        case 'Year':
            return toggleMapping[group][value] === 'arsmodell' ? <Year {...props} /> : null;
        default:
            // This has mappings to the base inputControl values, such as TextInput, DropDown etc..
            return <InputControl {...props} />;
    }
}
